import actionTypes from '../actionTypes';

const fetchStatus = () => {
  return {
    type: actionTypes.accountVerification.FETCH_STATUS,
  };
}

const fetchStatusOk = (data) => {
  return {
    type: actionTypes.accountVerification.FETCH_STATUS_OK,
    data: data
  };
};

const fetchStatusError = (error) => {
  return {
    type: actionTypes.accountVerification.FETCH_STATUS_ERROR,
    error: error,
  };
}

const emailVerified = (isVerified) => {
  return {
    type: actionTypes.accountVerification.EMAIL_VERIFIED,
    isVerified: isVerified,
  };
}

const sendVerificationEmail = () => {
  return {
    type: actionTypes.accountVerification.SEND_VERIFICATION_EMAIL
  };
}

const sendVerificationEmailError = (error) => {
  return {
    type: actionTypes.accountVerification.SEND_VERIFICATION_EMAIL_ERROR,
    error: error
  };
}

const setVerificationEmailSent = () => {
  return {
    type: actionTypes.accountVerification.SET_VERIFICATION_EMAIL_SENT,
  };
}

const clearVerificationEmailSent = () => {
  return {
    type: actionTypes.accountVerification.CLEAR_VERIFICATION_EMAIL_SENT
  };
}

export const accountVerificationActions = {
  fetchStatus,
  fetchStatusOk,
  fetchStatusError,
  emailVerified,
  sendVerificationEmail,
  sendVerificationEmailError,
  setVerificationEmailSent,
  clearVerificationEmailSent,
};